import useStorage from './storage/useStorage';

export default function useRxConditionId() {
  return useStorage('rx_condition_id', '');
}
